import { useEffect, useState } from 'react';
import { OrganisationDto, RoleUserOrgAssociationDto } from '@/apiClient';
import { PrivateContextData } from '@/components/private/PrivateContext';
import { SELECTED_ORG_ID } from '@/configs/storageKeys';

export const usePrivateContextState = () => {
  // Initialised as `undefined` so consumers can distinguish "not fetched yet"
  // from "user has no memberships". `PostLoginFlow` later sets this to the
  // fetched array (or `[]` on fetch error). Anything reading
  // `userOrganisations?.length` keeps working unchanged.
  const [userOrganisations, setUserOrganisations] = useState<
    RoleUserOrgAssociationDto[] | undefined
  >(undefined);
  // Holds the resolved `OrganisationDto` (not the membership association), to
  // match `PrivateContextData.selectedOrganisation` in PrivateContext.
  const [selectedOrganisation, setSelectedOrganisation] = useState<
    OrganisationDto | undefined
  >(undefined);
  const [selectedOrganisationId, setSelectedOrganisationId] = useState(
    Number(window.sessionStorage.getItem(SELECTED_ORG_ID)) || undefined,
  );
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [contextData, setContextData] = useState<PrivateContextData>({});

  useEffect(() => {
    setContextData((prev) => ({
      ...prev,
      selectedOrganisation,
      setSelectedOrganisation,
      selectedOrganisationId,
      setSelectedOrganisationId,
      userOrganisations,
      setUserOrganisations,
      showSplashScreen,
      setShowSplashScreen,
    }));
  }, [
    selectedOrganisation,
    selectedOrganisationId,
    userOrganisations,
    showSplashScreen,
  ]);

  return {
    userOrganisations,
    setUserOrganisations,
    selectedOrganisation,
    setSelectedOrganisation,
    selectedOrganisationId,
    setSelectedOrganisationId,
    showSplashScreen,
    setShowSplashScreen,
    contextData,
    setContextData,
  };
};
